// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7920":"0874145f7875edd0","21175":"a558b1509377f707","45723":"a3446457145c2b3d","49820":"a28115c40f1ae7de","88402":"55c4bbec04c81e4f"}[chunkId] + ".css";
};